interface WarningSection {
  head: string;
  body: string;
}

export const RISK_WARNING_BANNER_TITLE = "Exploratory insights. Good for direction, not decisions.";

export const RISK_WARNING_BANNER_SECTIONS: readonly WarningSection[] = [
  {
    head: "Uncover directional patterns.",
    body: "Use EnlightenMe to spot themes and surface areas worth exploring."
  },
  {
    head: "Guide your thinking.",
    body: "It identifies patterns across your conversations to help you decide where to look next, not to replace a closer look."
  },
  {
    head: "Treat numbers as indicative.",
    body: "Figures are estimates, example calls are illustrative and not always precise, and the further you drill into sub-groups, the less certain the patterns become."
  }
];

export const RISK_WARNING_BANNER_FOOTER =
  "Always validate significant findings against source data before making business decisions.";

export const RISK_WARNING_DISCLAIMER_LABEL = "Full disclaimer";
